import { assign, createMachine, interpret, State } from 'xstate-v4'
import { NavigatorGeolocationService } from './GeolocationService'
import { GeoCoordinates, GeolocationError } from './schema'

export interface GeolocationContext {
  point: GeoCoordinates | null
  errorStatus: GeolocationError
}

export function getGeolocationMachine() {
  return interpret(
    createMachine<GeolocationContext>(
      {
        id: 'geolocation',
        initial: 'idle',
        context: {
          point: null,
          errorStatus: '',
        },
        states: {
          idle: {
            on: {
              LOCATE: 'locating',
            },
          },
          locating: {
            invoke: {
              src: 'getCoordinates',
              onDone: {
                actions: 'setGeoPoint',
                target: 'success',
              },
              onError: {
                actions: 'setErrors',
                target: 'error',
              },
            },
          },
          error: {
            type: 'final',
          },
          success: {
            type: 'final',
          },
        },
      },
      {
        actions: {
          setGeoPoint: assign((_, { data }: { data: GeoCoordinates }) => ({
            point: data,
          })),
          setErrors: assign((_, { data }: { data: GeolocationError }) => ({
            errorStatus: data,
          })),
        },
        services: {
          getCoordinates: () =>
            new NavigatorGeolocationService().getCoordinates(),
        },
      },
    ),
  )
}

export type GeolocationState = State<GeolocationContext>
